import { Navigate } from "react-router-dom";
import useBulkUploadsStore from "../../stores/bulkUploadsStore";

export default function BatchSummaryFlowGuard({ children }) {
  const isViewingBatch = useBulkUploadsStore((state) => state.isViewingBatch);

  if (!isViewingBatch) {
    return <Navigate to="/bulkpayments" replace />;
  }

  return children;
}
